import { NavigateFunction } from 'react-router-dom';
import { handleRedirect } from './handle-redirect';

export const multiRedirect = (urls: string[], navigate: NavigateFunction) => {
    for (const url of urls) {
        handleRedirect(url, navigate);
    }
};
